<template>
    <div>
        <a @click.prevent="addNewItem = true" href="#" class="-ml-px relative flex items-center px-4 py-2 border text-sm font-medium rounded-md text-blue-50 bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500">
            <svg class="w-6 h-6 mr-1 text-blue-100" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
            <span>Add</span>
        </a>

        <div v-if="addNewItem" class="bg-blue-50 border-blue-400 rounded-lg my-4 pt-8 pb-5 px-5 relative">
            <div class="fixed z-10 inset-0 overflow-y-auto">
                <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 transition-opacity" aria-hidden="true" @click="addNewItem = false">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all ease-out duration-300 sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <div class="flex justify-between items-center mb-4 bg-blue-50 border-b border-blue-100 p-4">
                            <p class="text-xl font-semibold text-blue-900">Add New</p>
                            <svg @click="addNewItem = false" class="w-6 h-6 text-gray-400 cursor-pointer hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                        </div>
                        <div class="px-4 pt-5 pb-4 sm:p-6">
                            <form @submit.prevent="submit"  class="grid grid-cols-6 gap-6">
                                <div class="col-span-6 sm:col-span-3">
                                    <label for="pay_interest" class="block text-sm font-medium text-gray-700">Pay Interest</label>
                                    <text-input v-model="newItem.pay_interest" type="number" step=".01" name="pay_interest" id="pay_interest" class="mt-1" />
                                </div>
                                <div class="col-span-6 sm:col-span-3">
                                    <label for="charge_interest" class="block text-sm font-medium text-gray-700">Charge Interest</label>
                                    <text-input v-model="newItem.charge_interest" type="number" step=".01" name="charge_interest" id="charge_interest" class="mt-1" />
                                </div>
                                <div class="col-span-6 sm:col-span-3">
                                    <label for="pay_interest" class="block text-sm font-medium text-gray-700">Month</label>
                                    <select-input v-model="newItem.interest_rate_month" name="interest_date_month" id="interest_date_month" class="mt-1">
                                        <option v-for="month in 12" :value="month">{{ month }}</option>
                                    </select-input>
                                </div>
                                <div class="col-span-6 sm:col-span-3">
                                    <label for="charge_interest" class="block text-sm font-medium text-gray-700">Year</label>
                                    <select-input v-model="newItem.interest_rate_year" name="interest_date_year" id="interest_date_year" class="mt-1">
                                        <option v-for="year in years" :value="year">{{ year }}</option>
                                    </select-input>
                                </div>

                                <div class="col-span-6">
                                    <div class="flex justify-end items-center mt-2">

                                        <loading-button :loading="saving"  type="submit" class="">
                                            Save
                                        </loading-button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingButton from "@/Shared/LoadingButton";
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'

export default {
    components: { TextInput, SelectInput, LoadingButton },
    data() {
        return {
            saving: false,
            addNewItem: false,
            newItem: {
                pay_interest: "0.00",
                charge_interest: "0.00",
                interest_rate_month: new Date().getMonth() + 1,
                interest_rate_year: new Date().getFullYear()
            }
        }
    },
    methods: {
        submit() {
            this.$inertia.post(this.route('settings.interest-rates.store'), this.newItem, {
                onStart: () => this.saving = true,
                onFinish: () => this.saving = false,
                onSuccess: () => {
                    this.addNewItem = false,
                    this.newItem = {
                        pay_interest: "0.00",
                        charge_interest: "0.00",
                        interest_rate_month: new Date().getMonth() + 1,
                        interest_rate_year: new Date().getFullYear()
                    }
                },
            })
        }
    },
    computed : {
        years () {
            const year = new Date().getFullYear()
            return Array.from({length: year - 2010}, (value, index) => 2011 + index)
        }
    }
}
</script>
